import tw from 'twin.macro';

export const ContentCenter = tw.div``;

export const CloseIconWrap = tw.div`flex justify-end pb-10`;

export const CloseModalButton = tw.button`absolute top-0 right-0 mt-8 mr-8 hocus:text-red-600`;

export const CloseIcon = tw.i`text-3xl`;
